<template>
    <div
        :id="id"
        :aria-labelledby="id"
        class="modal fade pt-popin-mobile-details"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-ob1-component="Popin"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content pb-0 px-1 px-md-2">
                <div v-if="cartOfferDetails">
                    <!--/* header */-->
                    <div class="modal-header">
                        <button
                            type="button"
                            class="btn-close pt-2 pt-md-0"
                            data-bs-dismiss="modal"
                            aria-label="Fermer"
                            style="display: block !important"
                        >
                            <span class="icon icon-delete" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            class="btn-close ob1-link-arrow back"
                            data-bs-dismiss="modal"
                            style="display: none !important"
                        >
                            Fermer
                        </button>
                    </div>

                    <!--/* content */-->
                    <div class="modal-body px-0">
                        <div class="row">
                            <div class="col-12 px-2 px-md-3 px-lg-5">
                                <!--/* header offre */-->
                                <div class="row">
                                    <div class="col-12">
                                        <strong
                                            v-if="showBanner(cartOfferDetails.banner)"
                                            v-msh-html="cartOfferDetails.banner"
                                            class="ob1-tag ob1-tag-primary mb-1"
                                        />
                                        <h2 class="visually-hidden">
                                            {{ cartOfferDetails.offerType }} {{ cartOfferDetails.name }}
                                        </h2>
                                        <p v-if="cartOfferDetails.offerType" class="pt-xl-1 py-0 mb-0 fw-bold" aria-hidden="true">
                                            {{ cartOfferDetails.offerType }}
                                        </p>
                                        <h2
                                            :class="cartOfferDetails.offerType ? 'h1' : 'h4'"
                                            class="py-0 mb-0"
                                            aria-hidden="true"
                                        >
                                            {{ cartOfferDetails.name }}
                                        </h2>
                                    </div>
                                </div>

                                <!--/* attributs accordion */-->
                                <div class="row mb-4 mt-3">
                                    <div class="col-12">
                                        <div
                                            v-if="cartOfferDetails.detailAttributes && cartOfferDetails.detailAttributes.length > 0"
                                            class="accordion"
                                            itemscope=""
                                            itemtype="https://schema.org/FAQPage"
                                        >
                                            <div
                                                v-for="(detailAttribute, attributeIndex) in cartOfferDetails.detailAttributes"
                                                :key="`${cartOfferDetails.idSeo}-${attributeIndex}`"
                                                class="card multi"
                                                itemscope=""
                                                itemprop="mainEntity"
                                                itemtype="https://schema.org/Question"
                                            >
                                                <div class="card-header">
                                                    <button
                                                        :id="`faqQuestion-${cartOfferDetails.idSeo}-${attributeIndex}`"
                                                        class="collapsed"
                                                        data-bs-toggle="collapse"
                                                        :data-bs-target="`#faqAnswer-${cartOfferDetails.idSeo}-${attributeIndex}`"
                                                        :aria-controls="`faqAnswer-${cartOfferDetails.idSeo}-${attributeIndex}`"
                                                        aria-expanded="false"
                                                        type="button"
                                                    >
                                                        <div class="accordion-card-title">
                                                            <p class="accordion-title mb-0" itemprop="name">
                                                                <span>{{ detailAttribute.titleAttribute }}</span>
                                                            </p>
                                                            <p class="accordion-icon mb-0" aria-hidden="true" />
                                                        </div>
                                                    </button>
                                                </div>
                                                <div
                                                    :id="`faqAnswer-${cartOfferDetails.idSeo}-${attributeIndex}`"
                                                    class="collapse"
                                                    :aria-labelledby="`faqQuestion-${cartOfferDetails.idSeo}-${attributeIndex}`"
                                                    role="region"
                                                    itemscope
                                                    itemprop="acceptedAnswer"
                                                    itemtype="https://schema.org/Answer"
                                                >
                                                    <div class="accordion-card-body standard" itemprop="text" v-html="detailAttribute.textAttribute" />
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="text-center text-muted py-4">
                                            <p>Aucun détail disponible pour cette offre.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--/* footer */-->
                    <div class="sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center">
                        <ob1-boutons
                            v-if="closeButtonLabel"
                            :is-button="true"
                            :is-primary="true"
                            :is-wide="false"
                            :label="closeButtonLabel"
                            data-bs-dismiss="modal"
                            @ob1-boutons-click="onClose"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CartOfferDetailPopin',
    props: {
        id: {
            type: String,
            required: true,
        },
        cartOfferDetails: {
            type: Object,
            required: true,
        },
        closeButtonLabel: {
            type: String,
            required: false,
            default: 'Fermer'
        }
    },
    computed: {
        brandLabel() {
            if (!this.cartOfferDetails.brand) {
                return '';
            }
            return this.cartOfferDetails.brand === 'ORANGE' ? 'Forfait Orange' : 'Forfait Sosh';
        },
        nameAccessibility() {
            const brandAccessibility = this.brandLabel;
            const name = this.cartOfferDetails.name || '';

            // Replace abbreviations with full text for accessibility
            const nameAccessibility = name
                .replace(/Mo/g, ' méga Octet')
                .replace(/Go/g, ' giga Octet');

            return `${brandAccessibility} ${nameAccessibility}`;
        },
    },
    methods: {
        showBanner(banner) {
            return banner && banner !== '';
        },
        onClose() {
            this.$emit('close');
        }
    },
}
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
    .pt-popin-mobile-details {
        padding-top: 110px !important;
    }
}

.btn-close::before {
    display: none !important;
}

.modal-dialog .modal-header {
    position: inherit !important;
}

.modal-dialog .modal-header.box-shadow {
    box-shadow: none !important;
}

// correctif accordion border dernier element
.accordion .card.multi:last-child .card-header button {
    border-bottom: 0;
}

.accordion .card.multi:last-child {
    border-bottom: 1px solid #ccc;
}
</style>

